import * as yup from 'yup';

export const campaignFormValidationSchema = yup.object().shape({
  name: yup.string().required('Campaign Name is required').default(''),
  altId: yup.string().default(''),
  advertiser: yup
    .object({ label: yup.string().required(), value: yup.number().required() })
    .required('Advertiser is required')
    .nullable()
    .default(null),
});
